module.exports = __webpack_public_path__ + "static/media/get_more_left_img.10a9d8fc.svg";